import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { RadioContainer, HiddenRadio, StyledRadio, RadioDot, RadioLabel } from './styled';

class RadioComponent extends Component {
    render() {
        const { name, value, checked, onChange, label, disabled } = this.props;

        return (
            <RadioContainer disabled={disabled}>
                <HiddenRadio
                    type="radio"
                    name={name}
                    value={value}
                    checked={checked}
                    onChange={onChange}
                    disabled={disabled}
                />
                <StyledRadio checked={checked} disabled={disabled}>
                    <RadioDot checked={checked} />
                </StyledRadio>
                <RadioLabel disabled={disabled}>{label}</RadioLabel>
            </RadioContainer>
        );
    }
}

RadioComponent.propTypes = {
    name: PropTypes.string.isRequired,
    value: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
        PropTypes.bool,
    ]).isRequired,
    checked: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    label: PropTypes.string.isRequired,
    disabled: PropTypes.bool,
};

RadioComponent.defaultProps = {
    disabled: false,
};

export default RadioComponent;
